<template>
    <div>
        <button-tooltip :tooltip="$t('common.config')">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-on="on" v-bind="attrs" @click="showConfig">
                    <v-icon size="20" color="txtSecondary">mdi-cog-outline</v-icon>
                </v-btn>
            </template>
        </button-tooltip>

        <config-drawer :show-subscription-cancel="!!currentSubscription" @click:edit="showEditProfile"
            @click:cancel-subscription="onSubscriptionCancelClick" @click:delete-account="showDeleteAccount"
            ref="config" />

        <edit-profile-dialog ref="editProfile" />

        <cancel-subscription v-if="currentSubscription" ref="cancelSubscription" :subscription="currentSubscription" />

        <kimsa-confirm ref="deleteAccount" :title="$t('common.delete_account_title')"
            :content="$t('common.delete_account_subtitle')" :loading="loadingDelete" :persistent="false"
            @confirm="onConfirmDelete" :close-on-confirm="false" :alert-mode="true" />
    </div>
</template>

<script>

import ConfigDrawer from "@/components/student/ConfigDrawer";
import CancelSubscription from "@/components/student/CancelSubscription";
import EditProfileDialog from "@/components/student/EditProfileDialog";
import KimsaConfirm from '../KimsaConfirm.vue';
import ButtonTooltip from '../ButtonTooltip.vue';
import firebase from "@/utils/Firebase";

export default {
    components: {
        ButtonTooltip,
        ConfigDrawer,
        CancelSubscription,
        EditProfileDialog,
        KimsaConfirm,
    },
    data() {
        return {
            loadingDelete: false,
        }
    },
    computed: {
        currentSubscription() {
            const vm = this
            return vm.account?.studentSubscription || null
        }
    },
    methods: {
        showConfig() {
            const vm = this
            vm.$refs.config.show()
        },
        hideConfig() {
            const vm = this
            vm.$refs.config.hide()
        },
        async hideConfigThen(showFn) {
            this.hideConfig()
            await new Promise(resolve => setTimeout(resolve, 300))
            showFn()
        },
        showEditProfile(mode) {
            this.hideConfigThen(() => this.$refs.editProfile.show(mode))
        },
        onSubscriptionCancelClick() {
            this.hideConfigThen(() => this.$refs.cancelSubscription.show())
        },
        showDeleteAccount() {
            this.hideConfigThen(() => this.$refs.deleteAccount.show())
        },
        onConfirmDelete() {
            const vm = this
            vm.loadingDelete = true
            vm.deleteAccount().catch(() => {})
            setTimeout(() => {
                vm.$refs.deleteAccount.hide()
                vm.loadingDelete = false
                vm.replaceRoute({ name: 'login' })
            }, 3000)
        },
        deleteAccount: firebase.functions().httpsCallable('httpPayments-deleteAccount'),
    },
}
</script>